import ShippingPackage from '../src/ShippingPackage';
export default ShippingPackage;
